<div class="modal-header timeline-modal-header">
  <div class="timeline-modal-heading">
    <span class="timeline-modal-heading__icon">
      <lucide-icon name="history" [size]="19"></lucide-icon>
    </span>
    <div class="timeline-modal-heading__copy">
      <h5 class="modal-title" id="timelineTitle">{{ 'BRAND.LIST.TIME_LINE' | translate }}</h5>
      <span class="timeline-modal-subtitle" *ngIf="title">{{ title }}</span>
    </div>
  </div>
  <button type="button" class="close timeline-modal-close" (click)="close()"
          [attr.aria-label]="'COMMON.BUTTONS.CLOSE' | translate">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body timeline-modal-body" tabindex="0">

  <!-- Sin historial o error al pedirlo -->
  <div class="timeline-modal-notice" *ngIf="message" role="note">
    <lucide-icon name="info" [size]="18"></lucide-icon>
    <span>{{ message }}</span>
  </div>

  <!-- Un paso por estado: hecho (con fecha), actual (el del objeto) o pendiente -->
  <ol class="timeline-steps" *ngIf="approvalList.length > 0" [attr.aria-labelledby]="'timelineTitle'">
    <li class="timeline-step" *ngFor="let item of approvalList; let i = index"
        [class.is-current]="isCurrent(item)"
        [class.is-linked]="isLinked(i)"
        [class.is-done]="!isCurrent(item) && !!item.createdAt"
        [class.is-skipped]="isSkipped(i)"
        [attr.aria-current]="isCurrent(item) ? 'step' : null">

      <!-- Hecho: check · Salteado: skip · Actual: punto lleno · Pendiente: vacío -->
      <span class="timeline-step__point" aria-hidden="true">
        <lucide-icon *ngIf="item.createdAt && !isCurrent(item)" name="check" [size]="15"></lucide-icon>
        <lucide-icon *ngIf="isSkipped(i)" name="skip-forward" [size]="13" class="timeline-step__skip"></lucide-icon>
      </span>

      <div class="timeline-step__card">
        <div class="timeline-step__top">
          <span class="timeline-step__status">{{ item.status.name | translateField: { obj: item.status, property: 'name' } }}</span>
          <span class="timeline-step__date" *ngIf="item.createdAt">
            <lucide-icon name="calendar" [size]="13"></lucide-icon>
            <span>{{ item.createdAt | date: 'dd-MM-yyyy' }}</span>
          </span>
        </div>

        <div class="timeline-step__user" *ngIf="item.createdUser">
          <!-- Foto de Entra; si no, el avatar local; si no, las iniciales (como en users-list) -->
          <img *ngIf="photos[item.createdUser.entraReferenceId]; else localAvatar" class="timeline-step__avatar"
               [src]="photos[item.createdUser.entraReferenceId]" alt="" />
          <ng-template #localAvatar>
            <img *ngIf="item.createdUser.avatar; else initialsAvatar" class="timeline-step__avatar"
                 src="assets/images/portrait/small/{{ item.createdUser.avatar }}" alt="" />
          </ng-template>
          <ng-template #initialsAvatar>
            <span class="timeline-step__avatar" aria-hidden="true">{{ initials(item.createdUser) }}</span>
          </ng-template>
          <span class="timeline-step__name">{{ fullName(item.createdUser) }}</span>
        </div>
      </div>
    </li>
  </ol>

</div>

<div class="modal-footer timeline-modal-footer">
  <button type="button" class="btn btn-outline-primary timeline-modal-action" rippleEffect (click)="close()">
    <lucide-icon name="x" [size]="16"></lucide-icon>
    <span>{{ 'COMMON.BUTTONS.CLOSE' | translate }}</span>
  </button>
</div>
